<template>
  <article class="layout-section -bg-shade">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title">Affichage en tuiles</h2>
      <p>
        Les cartes sont idéales pour séparer les infos sans tout mélanger. Chaque carte agit comme un petit résumé
        visuel : claire, aérée, facile à explorer.
      </p>
    </div>

    <section class="layout-grid">
      <div class="layout-grid__item card -smaller">
        <p>Tuile simple</p>
      </div>

      <div class="layout-grid__item card -smaller">
        <p>Tuile simple</p>
      </div>

      <div class="layout-grid__item card">
        <h3 class="card__title">Tuile avec titre et paragraphe</h3>
        <p>
          Earum euismod natoque mollit hendrerit sagittis metus nulla netus integer, pulvinar corporis sagittis netus
          magnis.
        </p>
      </div>

      <div class="layout-grid__item card">
        <h3 class="card__title">Tuile avec titre et paragraphe</h3>
        <p>
          Earum euismod natoque mollit hendrerit sagittis metus nulla netus integer, pulvinar corporis sagittis netus
          magnis.
        </p>
      </div>

      <div class="card -bigger">
        <h4 class="card__uptitle">Catégorie</h4>
        <h3 class="card__title">Grande tuile avec catégorie, titre et paragraphe</h3>
        <p>
          Morbi nunc, litora, fugiat cumque sit aut nascetur porttitor ornare tincidunt deserunt mollit vivamus delectus
          habitant mattis hymenaeos primis, voluptatibus. Sint, auctor ea cumque! Irure tristique mauris velit! Mauris
          cillum! Doloribus veniam leo phasellus, aliquam! Eleifend incidunt possimus dictumst, aspernatur, occaecat
          felis in cupidatat fringilla non sodales nonummy, nonummy, quidem. Imperdiet asperiores. Arcu officia fuga,
          reiciendis, mollit! Quis distinctio amet, libero id ante sapien minus.
        </p>
      </div>

      <div class="card -bigger">
        <h3 class="card__title">Tuile avec titre, paragraphe et lien</h3>
        <p>
          Morbi nunc, litora, fugiat cumque sit aut nascetur porttitor ornare tincidunt deserunt mollit vivamus delectus
          habitant mattis hymenaeos primis, voluptatibus. Sint, auctor ea cumque! Irure tristique mauris velit! Mauris
          cillum! Doloribus veniam leo phasellus, aliquam! Eleifend incidunt possimus dictumst, aspernatur, occaecat
          felis in cupidatat fringilla non sodales nonummy, nonummy, quidem. Imperdiet asperiores. Arcu officia fuga,
          reiciendis, mollit! Quis distinctio amet, libero id ante sapien minus.
        </p>
        <button class="link card__cta">
          En savoir plus
          <SvgIcon id="action-arrow" />
        </button>
      </div>

      <!-- <section class="layout-grid__item -third card -alt">
        <figure class="card__figure"/>

        <div class="card__content">
          <p>Tuile simple</p>
        </div>
      </section> -->
    </section>
  </article>
</template>

<script>
export default {
  name: 'DemoCards'
}
</script>
